$(document).ready(function() {

  'use strict';

  // -----------
  // Mobile menu
  // -----------

  var handleMatchMedia = function (mediaQuery) {
    // ≤ 1023px
    if (mediaQuery.matches) {
      // crear el botó del menú
      // $('.main-nav').prepend('<button class="hamburger hamburger--3dx menu-button" aria-expanded="false" aria-label="Menú" id="nav"><span class="hamburger-box"><span class="hamburger-inner"></span></span><span class="menu-button__label vh">Menú</span></button>')
      // ocultar el menú
      $('.menu-wrapper').attr('hidden','').addClass('js-hidden');
      // clicar el botó
      $('.main-nav button').on('click', function() {
        // afegir classe al botó
        $(this).toggleClass('is-active');
        // afegir classe al body
        $('body').toggleClass('js-menu-open');
        // canviar atributs del botó i del menú
        if ($(this).attr('aria-expanded') == 'true') {
          $(this).attr('aria-expanded', 'false');
          $('.menu-wrapper').attr('hidden','').addClass('js-hidden');
        }
        else {
          $(this).attr('aria-expanded', 'true');
          $('.menu-wrapper').removeAttr('hidden').removeClass('js-hidden');
        }
      });
    }
    // ≥ 1024px
    else {
      // treure el botó
      // $('.main-nav button').remove();
      // mostrar el menú
      $('.menu-wrapper').removeAttr('hidden').removeClass('js-hidden');
    }
  },
  mq = window.matchMedia('only screen and (max-width: 1023px)');
  handleMatchMedia(mq);
  mq.addListener(handleMatchMedia);



  // ----------------
  // Cercador desktop
  // ----------------

  // crear botó del desplegable
  $('.menu-lang--desktop').after('<button class="js-button" aria-expanded="false" aria-label="Buscador"><img src="/media/img/cercador-portada-negatiu.svg" alt="Abrir buscador"/></button>')
  // clicar botó
  $('.js-button').on('click', function() {
    // canviar atributs del botó i del form
    if ($(this).attr('aria-expanded') == 'true') {
      $(this).attr('aria-expanded', 'false');
      $('.s-desktop').addClass('js-hidden');
    }
    else {
      $(this).attr('aria-expanded', 'true');
      $('.s-desktop').removeClass('js-hidden');
    }
  });



  // -----------------
  // Desplegables home
  // -----------------

  // clicar botó
  $('.section--esp button').on('click', function() {
    // canviar atributs del botó i del desplegable
    if ($(this).attr('aria-expanded') == 'true') {
      $(this).attr('aria-expanded', 'false');
      // canviar classe
      $(this).removeClass('btn--icon-close').addClass('btn--icon-open');
      // treure classe del div.more-info
      $(this).parent().parent().parent().next().removeClass('js-open');
      // treure classe del div.section__wrapper
      $(this).parent().parent().parent().parent().removeClass('js-active');
    }
    else {
      $(this).attr('aria-expanded', 'true');
      // canviar classe
      $(this).removeClass('btn--icon-open').addClass('btn--icon-close');
      // posar classe al div.more-info
      $(this).parent().parent().parent().next().addClass('js-open');
      // posar classe al div.section__wrapper
      $(this).parent().parent().parent().parent().addClass('js-active');

      $(this).parent().parent().parent().next().find('.btn').addClass('enter-effect--2');
    }
  });



  // ----------
  // feature.js
  // ----------

  if (feature.svg) {
    $('html').addClass('svg');
  }



  // --------------------------------------------------------------------------------------
  // skip link (https://www.bignerdranch.com/blog/web-accessibility-skip-navigation-links/)
  // --------------------------------------------------------------------------------------

  // bind a click event to the 'skip' link
  $(".skip-link").click(function(event){

      // strip the leading hash and declare
      // the content we're skipping to
      var skipTo="#"+this.href.split('#')[1];

      // Setting 'tabindex' to -1 takes an element out of normal
      // tab flow but allows it to be focused via javascript
      $(skipTo).attr('tabindex', -1).on('blur focusout', function () {

          // when focus leaves this element,
          // remove the tabindex attribute
          $(this).removeAttr('tabindex');

      }).focus(); // focus on the content container
  });



  // -----------------
  // Canvi svg per png
  // -----------------

  if (!feature.svg) {
    var imgs = document.getElementsByTagName('img');
    var endsWithDotSvg = /.*\.svg$/;
    var i = 0;
    var l = imgs.length;
    for (; i !== l; ++i) {
        if (imgs[i].src.match(endsWithDotSvg)) {
            imgs[i].src = imgs[i].src.slice(0, -3) + 'png';
        }
    }
  }



  // -----------------
  // Smooth scroll top
  // -----------------

  var hash = window.location.hash;
  if (hash != '') {
    var target = $(hash);
    if (hash == '#comments') {
      $('.blog-comments').prop('open', true);
    }
  }

  $('a[href*="#"]:not([href="#"],[href="#menu"])').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      if (this.hash == '#comments') {
        $('.blog-comments').prop('open', true);
      }
    }
  });

  if (window.matchMedia('(max-width: 64em)').matches) {
    $('.blog-nav .has-dropdown > a').on('click', function(event){
        event.preventDefault();
        $('.blog-nav .has-dropdown.open').removeClass('open');
        $(this).parent().toggleClass('open');
    });

  }



  if (window.matchMedia('(min-width: 64em)').matches) {
    $(window).scroll(function() {
      if ($(this).scrollTop() > 400) {
          $(".top").fadeIn();
      } else {
          $(".top").fadeOut();
      }
    });
    // var headerHeight = 82; // fixed header height
    $(function() {
      $('a[name]').addClass('anchor_offset');
      /*en cas de menú sticky, alçada àncores. Afegir css:
        .anchor_offset:before {
          content: " ";
          display: block;
          height: 120px; en funció l'alçada del menú sticky
          margin-top: -120px; en funció l'alçada del menú sticky
          visibility: hidden;
          }*/

    var hash = window.location.hash;
    if (hash != '') {
        var target = $(hash);
        target = target.length ? target : $('[name=' + hash.slice(1) +']');
        if (target.length) {
            $('html, body').animate({
                scrollTop: target.offset().top
            }, 1000);
            return false;
        }
    }

      $('a[href*="#"]:not([href="#"],[href="#menu"])').click(function() {
        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
          var target = $(this.hash);

          target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
          if (target.length) {
              // if (window.matchMedia("(min-width: 64.0625em)").matches) {
              //       $('html, body').animate({
              //         scrollTop: target.offset().top - headerHeight
              //       }, 1000);
              // } else {
              //       $('html, body').animate({
              //         scrollTop: target.offset().top
              //       }, 1000);
              // }
              $('html, body').animate({
                scrollTop: target.offset().top
              }, 1000);
            return false;
          }
        }
      });
    });
  }



  // -------------
  // Sticky header
  // -------------

  var handleMatchMedia2 = function (mediaQuery) {
    // ≥ 1024px
    if (mediaQuery.matches) {
      // var lastScrollTop = 100;
      var lastScrollTop = 255;
      $(window).scroll(function(event){
          var st = $(this).scrollTop();
          if (st > lastScrollTop){
              $('.main-header').addClass('sticky');
              $('body').addClass('sticky-header');
          } else {
              $('.main-header').removeClass('sticky');
              $('body').removeClass('sticky-header');
          }
          // lastScrollTop = st;
      });
    }
  },
  mq2 = window.matchMedia('only screen and (min-width: 1024px)');
  handleMatchMedia2(mq2);
  mq2.addListener(handleMatchMedia2);



  // ------------
  // Match height
  // ------------

  $('.h-box').matchHeight();



  // -------------
  // Animació svgs
  // -------------

  // svgs home
  if ($('[id^=svg-h-]').length ) {
    new Vivus('svg-h-1', {
      duration: 100,
      animTimingFunction: Vivus.EASE_OUT
    });
    new Vivus('svg-h-2', {
      duration: 100,
      animTimingFunction: Vivus.EASE_OUT
    });
    new Vivus('svg-h-3', {
      duration: 100,
      animTimingFunction: Vivus.EASE_OUT
    });
    new Vivus('svg-h-4', {
      duration: 100,
      animTimingFunction: Vivus.EASE_OUT
    });
    new Vivus('svg-h-5', {
      duration: 200,
      animTimingFunction: Vivus.EASE_OUT
    });
    new Vivus('svg-h-6', {
      duration: 100,
      animTimingFunction: Vivus.EASE_OUT
    });
  }

  // svg icones
  if ($('#svg-404').length ) {
    new Vivus('svg-404', {
      duration: 100,
      animTimingFunction: Vivus.EASE_OUT
    });
  }
  if ($('#svg-ok').length ) {
    new Vivus('svg-ok', {
      duration: 100,
      animTimingFunction: Vivus.EASE_OUT
    });
  }



  // -----------------
  // Custom file input
  // -----------------

  /*
      (https://tympanus.net/codrops/2015/09/15/styling-customizing-file-inputs-smart-way/)
      By Osvaldas Valutis, www.osvaldas.info
      Available for use under the MIT License
  */

  ;( function( $, window, document, undefined )
  {
      $( '.inputfile' ).each( function()
      {
          var $input   = $( this ),
              $label   = $input.next( 'label' ),
              labelVal = $label.html();

          $input.on( 'change', function( e )
          {
              var fileName = '';

              if( this.files && this.files.length > 1 )
                  fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
              else if( e.target.value )
                  fileName = e.target.value.split( '\\' ).pop();

              if( fileName )
                  $label.find( 'span' ).html( fileName );
              else
                  $label.html( labelVal );
          });

          // Firefox bug fix
          $input
          .on( 'focus', function(){ $input.addClass( 'has-focus' ); })
          .on( 'blur', function(){ $input.removeClass( 'has-focus' ); });
      });
  })( jQuery, window, document );



  // -----------
  // Collapsible
  // -----------

  $('.collapsible h3').each(function() {

    var $this = $(this);

    // create unique id for a11y relationship

    var id = 'collapsible-' + $this.index();

    // wrap the content and make it focusable

    $this.nextUntil('h3').wrapAll('<div id="'+ id +'" aria-hidden="true">');
    var panel = $this.next();

    // Add the button inside the <h3> so both the heading and button semanics are read

    $this.wrapInner('<button aria-expanded="false" aria-controls="'+ id +'">');
    var button = $this.children('button');

    // Toggle the state properties

    button.on('click', function() {
      var state = $(this).attr('aria-expanded') === 'false' ? true : false;
      $(this).attr('aria-expanded', state);
      panel.attr('aria-hidden', !state);
    });

  });


  $.fn.isInViewport = function() {
    var elementTop = $(this).offset().top + 40;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  };

  $(window).on('resize scroll load', function() {
    $('.enter-effect').each(function() {
      if ($(this).isInViewport()) {
        $(this).addClass('enter-effect--1');
      }
    });
    $('.enter-effect-2').each(function() {
      if ($(this).isInViewport()) {
        $(this).addClass('enter-effect--2');
      }
    });
  });

  if ($('ul.bordered-h').length && window.matchMedia('(min-width: 64em)').matches) {
    var heights = $("ul.bordered-h li").map(function() {
        return $(this).height();
    }).get(),
    maxHeight = Math.max.apply(null, heights);
    $("ul.bordered-h li").height(maxHeight);
  }
  //al validar formulari fer scroll tingui en compte sticky header
  $("input,textarea").focus(function(){
      var elementOffset = $(this).offset().top,
      scrollTop     = $(window).scrollTop(),
      distance      = (elementOffset - scrollTop);
      var label = $(this).closest('div').find('label');
      var addSpace = $('.main-header.sticky').height() + label.height() + 10 - distance;

      if(addSpace > 0)
      {
          var y = $(window).scrollTop();
          $(window).scrollTop(y-addSpace);
      }
  });


  $('.blog-newsletter .checkbox-group').hide();
  $('.blog-newsletter input[name="email"]').on('focus', function(){
    $('.blog-newsletter .checkbox-group').show();
  });


});
